import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Dialog } from '@totalsoft/rocket-ui';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

const ErrorModal = ({ onCloseModal, errorMessage }) => {
  const [t] = useTranslation();

  const [textIsCopied, setTextIsCopied] = useState(false);

  const copyToClipboard = () => {
    if (!textIsCopied) {
      setTextIsCopied(true);
      navigator.clipboard.writeText(errorMessage);
    }
  };

  return (
    <Dialog
      open
      aria-labelledby='error-modal-dialog-title'
      maxWidth='sm'
      fullWidth
      onClose={onCloseModal}
      disableEscapeKeyDown
      title={t('Notifier.FullErrorMessage')}
      content={errorMessage}
      actions={
        <BoxActionsWrapper forDialog>
          <Button id={'offerHeader_notifications_errorModal_copyBtn'} onClick={copyToClipboard}>
            {textIsCopied ? `${t('Copied')}!` : t('Copy')}
          </Button>
          <Button id={'offerHeader_notifications_errorModal_closeBtn'} onClick={onCloseModal}>
            {t('Close')}
          </Button>
        </BoxActionsWrapper>
      }
    />
  );
};

ErrorModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default ErrorModal;
